import { render, staticRenderFns } from "./ExpertUploadSelector.vue?vue&type=template&id=0b4a5708&scoped=true"
import script from "./ExpertUploadSelector.vue?vue&type=script&lang=js"
export * from "./ExpertUploadSelector.vue?vue&type=script&lang=js"
import style0 from "./ExpertUploadSelector.vue?vue&type=style&index=0&id=0b4a5708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4a5708",
  null
  
)

export default component.exports